import { addDays, getDay, format } from 'date-fns';

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/**
 * Given a start date, selected weekday names, and total session count,
 * compute the list of session dates.
 */
export function computeSessionDates(
  startDate: Date,
  selectedDays: string[],
  totalSessions: number,
  startTime: string
): Date[] {
  if (selectedDays.length === 0 || totalSessions <= 0) return [];

  const dayIndices = selectedDays.map(d => DAY_NAMES.indexOf(d)).filter(i => i >= 0).sort((a, b) => a - b);
  if (dayIndices.length === 0) return [];

  const sessions: Date[] = [];
  let current = new Date(startDate);

  // Start from the start date and look for matching days
  for (let safety = 0; safety < 365 && sessions.length < totalSessions; safety++) {
    const dayOfWeek = getDay(current);
    if (dayIndices.includes(dayOfWeek)) {
      const sessionDate = new Date(`${format(current, 'yyyy-MM-dd')}T${startTime}`);
      sessions.push(sessionDate);
    }
    current = addDays(current, 1);
  }

  return sessions;
}

export function formatSessionDays(days: string[]): string {
  if (days.length === 0) return '';
  if (days.length === 1) return `${days[0]}s`;
  if (days.length === 2) return `${days[0]}s & ${days[1]}s`;
  return days.map(d => `${d}s`).join(', ');
}

export { DAY_NAMES };
